import React from 'react';
import { IMAGE_BASE_URL } from '../../common/Constants';

const CommonProductCard = ({ productData }) => {
  return (
    <div>
      <div className='flex flex-wrap common-card-width gap-3'>
        {productData != undefined &&
          productData.length > 0 &&
          productData.map((product) => {
            return (
              <div key={product.id} className='product-mini-card'>
                <div className='rounded-lg border border-search-border-color product-card-height p-3 flex justify-between'>
                  <div className='flex w-full'>
                    <img
                      src={IMAGE_BASE_URL + '/' + product.icon}
                      alt='Bank Logo'
                      className='rounded-[8px]'
                      style={{ maxWidth: '100%', height: '60px' }}
                      width='60'
                      height='60'
                    />
                    <div className='ml-2 w-full'>
                      <div className='flex flex-wrap'>
                       {Boolean(product.hasPremium) && (
                          <div className='text-[10px] font-[400] rounded border border-search-border-color w-[60px] p-1 text-center mr-2 mb-2'>
                            Premium
                          </div>
                       )}
                        {Boolean(product.featured) &&(
                          <div className='text-[10px] font-[400] rounded border border-search-border-color w-[60px] p-1 text-center mb-2'>
                            Featured
                          </div>
                        )}
                      </div>
                      <div className='product-mini-card-info'>
                        <div className='product-mini-card-head'>
                          <h2>{product.name}</h2>
                        </div>
                        <div className='flex w-full'>
                          <div className='block w-full'>
                            <h2 className='text-[10px] font-[400]'>
                              Interest Rate
                            </h2>
                            <span className='text-[12px] font-[700]'>
                              {product.int_rate}%
                            </span>
                          </div>
                          <div className='text-right'>
                            <h2 className='text-[10px] font-[400] whitespace-nowrap'>
                              Monthly Installment
                            </h2>
                            <div className='text-[12px] font-[700] text-step-color-active'>
                              $&nbsp;{product.monthly_installment}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        {productData != undefined && productData.length == 0 && (
          <div className='w-full md:w-2/2 lg:w-4/4 xl:w-6/6 p-4'>
            <p>No Products</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommonProductCard;
